// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"452":"3ad53b8f","470":"d17b46a4"}[chunkId] + ".chunk.js";
};